import mappings from '../../build/mappings';
import Layer from 'ol/layer/Layer.js';
import Projection from 'ol/proj/Projection.js';
import Map from 'ol/Map.js';
import View from 'ol/View.js';
import {
    ZoomToExtent,
    defaults as defaultControls
} from 'ol/control.js'
import {composeCssTransform} from 'ol/transform.js';

const SRSVG = {
    'M': '<svg><path fill="###COLOR###" d="M 47.480999999999995 154.2510000000002 A 5.152 5.152 0 0 1 42.30899999999997 149.52900000000045 L 36.46199999999999 90.39100000000053 L 30.615999999999985 149.52900000000045 A 5.152 5.152 0 0 1 25.44399999999996 154.2510000000002 L 24.992999999999938 154.2510000000002 A 4.926 4.926 0 0 1 20.271999999999935 148.85100000000057 L 22.745999999999867 77.1220000000003 L 21.845999999999776 48.56500000000051 L 5.8819999999998345 84.09200000000055 A 3.05 3.05 0 0 1 1.834999999999809 85.66600000000017 A 3.05 3.05 0 0 1 0.25999999999976353 81.6190000000006 S 11.502999999999702 46.319000000000415 14.65099999999984 39.79600000000028 C 17.513999999999896 33.86700000000019 22.05099999999993 29.983000000000175 31.975999999999885 29.327000000000226 A 13.008 13.008 0 0 1 23.195999999999913 17.038000000000466 A 13.246 13.246 0 0 1 36.46199999999999 3.9960000000000946 A 13.051 13.051 0 0 1 49.503999999999905 17.038000000000466 A 13.058 13.058 0 0 1 40.81700000000001 29.338000000000648 C 50.68100000000004 30.012000000000626 55.197000000000116 33.89000000000033 58.04899999999998 39.801000000000386 C 61.422000000000025 46.322000000000116 72.66399999999999 81.6240000000007 72.66399999999999 81.6240000000007 A 3.05 3.05 0 0 1 71.08999999999992 85.67100000000028 A 3.05 3.05 0 0 1 67.04299999999989 84.09700000000066 L 51.07899999999995 48.57000000000062 L 50.17899999999986 77.12700000000041 L 52.65299999999979 148.85600000000068 A 5.035 5.035 0 0 1 47.93099999999981 154.2560000000003 L 47.480999999999995 154.2510000000002" stroke-width="1" stroke="#3B745D" style="transform: scale(0.15) translate(0px, 0px);"></path></svg>',
    'F': '<svg><path fill="###COLOR###" d="M 40.50999999999999 151.32900000000063 L 37.58699999999999 102.98500000000058 L 34.886999999999944 102.98500000000058 L 32.1869999999999 151.32900000000063 A 3.074 3.074 0 0 1 29.038999999999874 154.47700000000077 A 3.074 3.074 0 0 1 25.889999999999873 151.32900000000063 L 23.189999999999827 102.98500000000058 L 14.644999999999868 102.98500000000058 L 23.638999999999896 48.79500000000098 L 5.875999999999863 84.32300000000123 A 3.052 3.052 0 0 1 1.8279999999998608 85.89700000000084 A 3.052 3.052 0 0 1 0.2539999999999054 81.84900000000107 S 13.295999999999935 46.54900000000089 16.44399999999996 40.02600000000075 C 19.348999999999933 34.00700000000052 22.44399999999996 30.095000000001164 32.45799999999997 29.52600000000075 A 13.059 13.059 0 0 1 23.188999999999965 17.040000000000873 A 13.051 13.051 0 0 1 36.230999999999995 3.998000000000502 A 13.051 13.051 0 0 1 49.273000000000025 17.040000000000873 A 13.057 13.057 0 0 1 40.04500000000007 29.514000000001033 C 50.388000000000034 30.03400000000147 53.31600000000003 33.95900000000074 56.24500000000012 40.02300000000105 C 59.392000000000166 46.54400000000078 72.43400000000008 81.84600000000137 72.43400000000008 81.84600000000137 A 3.051 3.051 0 0 1 70.86000000000013 85.89400000000114 A 3.05 3.05 0 0 1 66.8130000000001 84.32000000000153 L 49.04900000000009 48.79200000000128 L 57.819000000000074 102.98200000000088 L 49.274000000000115 102.98200000000088 L 46.80000000000007 151.32600000000093 A 3.074 3.074 0 0 1 43.65300000000002 154.47400000000107 A 3.074 3.074 0 0 1 40.50999999999999 151.32900000000063 L 40.50999999999999 151.32900000000063" stroke-width="1" stroke="#f56a00" style="transform: scale(0.15) translate(0px, 0px);"></path></svg>',
    '?': '<svg><path fill="###COLOR###" d="M 34.7 102.1 C 29.6 102.1 25.500000000000004 106.3 25.500000000000004 111.3 C 25.500000000000004 116.39999999999999 29.6 120.5 34.7 120.5 S 43.900000000000006 116.4 43.900000000000006 111.3 S 39.8 102.1 34.7 102.1 L 34.7 102.1 L 34.7 102.1 M 36 46.3 C 43.4 46.3 47.9 50.3 47.9 57 C 47.9 62.8 43.1 66.5 38.099999999999994 70.4 C 32.699999999999996 74.5 27.199999999999996 78.80000000000001 27.199999999999996 86 C 27.199999999999996 89.7 29.599999999999994 93.4 34.3 93.4 C 39.5 93.4 40.599999999999994 90.7 41.699999999999996 87.60000000000001 C 42.199999999999996 86.30000000000001 42.699999999999996 84.9 43.599999999999994 83.7 C 44.8 81.9 47.199999999999996 80.2 50.099999999999994 78.2 C 56.4 73.7 65 67.6 65 57.1 C 65 40 49 33.9 35.4 33.9 C 28.599999999999998 33.9 21.7 36.3 16.4 40.4 C 11 44.4 8 49.8 8 55.2 C 8 59.900000000000006 11.6 61.900000000000006 15.2 61.900000000000006 C 20.2 61.900000000000006 21.7 58.800000000000004 23.4 55.2 C 25.3 51 27.6 46.3 36 46.3 L 36 46.3" stroke-width="1" stroke="#ccc" style="transform: scale(0.15) translate(0px, 0px)"></path></svg>'
}

const target = document.getElementById('map-target-wrapper');
let fullMap = false;

if (target && target.classList.contains('whole-map')) {
    fullMap = true;
}

const communesData = require('../../build/communes/all-communes.json');
const cantonMapping = mappings.cantonMapping;

let windowListenerSet = false;
let listenerBoxWidth = 0;
let listenerBoxHeight = 0;

let mapObject = null;

let year = 2023;

let communeDataFile = '/data/map-data-gde.json';
let cantonDataFile = '/data/map-data.json';

if (year === 2023) {
    communeDataFile = '/data/sd-b-17.02-20231022-map-data-gde.json';
    cantonDataFile = '/data/sd-b-17.02-20231022-map-data.json';
}


function boxResizer() {

    return;
    let targetHeight = target.clientHeight;
    let targetWidth = target.clientWidth;

    let targetRatio = targetWidth / targetHeight;
    let boxRatio = listenerBoxWidth / listenerBoxHeight;

    let newWidth = 0;
    let newHeight = 0;

    if (targetRatio > boxRatio) {
        newWidth = targetHeight / listenerBoxHeight * listenerBoxWidth
        newHeight = targetHeight;
    } else {
        newHeight = targetWidth / listenerBoxWidth * listenerBoxHeight
        newWidth = targetWidth;
    }

    let mapTarget = document.getElementById('map-target');
    mapTarget.setAttribute('style', `width: ${newWidth}px; height: ${newHeight}px`);
}

let communeData = null;

let loadCommuneFile = function () {
    return new Promise((resolve, reject) => {
        if (communeData) {
            return resolve(communeData);
        }
        $.getJSON(communeDataFile, function (data) {
            communeData = data;
            return resolve(communeData);
        });
    });
}

let cantonData = null;

let loadCantonFile = function () {
    return new Promise((resolve, reject) => {
        if (cantonData) {
            return resolve(cantonData);
        }
        $.getJSON(cantonDataFile, function (data) {
            cantonData = data;
            return resolve(cantonData);
        });
    });
}

/**
 * Load Map SVG based on data.mapPath
 *
 * @param data Object
 * @returns {Promise<Object>}
 */
const loadMap = (data) => new Promise((resolve, reject) => {
    let {mapPath} = data;
    const xhr = new XMLHttpRequest();

    xhr.open('GET', mapPath);
    xhr.addEventListener('load', function () {
        let mapContainer = document.createElement('div');

        const svg = xhr.responseXML.documentElement;
        svg.innerHTML = svg.innerHTML + '<defs><pattern id="gradient" patternUnits="userSpaceOnUse" width="10.5" height="10.5" patternTransform="rotate(45)"><line x1="0" y="0" x2="0" y2="10.5" stroke="#CCCCCC" stroke-width="15" /></pattern></defs>';
        mapContainer.ownerDocument.importNode(svg);
        mapContainer.appendChild(svg);

        // TODO: transfer me into build scripts
        let values = {minX: Infinity, maxX: -Infinity, minY: Infinity, maxY: -Infinity}
        let padding = 10;
        let paths = [];

        // use this for calculations, the commune layer is transformed
        paths = [
            ...svg.querySelectorAll('[id*="kant"] path'),
            ...svg.querySelectorAll('[id*="seen"] path')
        ];

        if (paths.length > 0) {
            paths.forEach(function (path) {
                let d = path.getAttribute('d');
                d.split(/\s?[A-Z]\s/)
                    .filter(x => x)
                    .forEach(coords => {
                        let [x, y] = coords.split(',');

                        values.minX = Math.min(values.minX, x);
                        values.minY = Math.min(values.minY, y);

                        values.maxX = Math.max(values.maxX, x);
                        values.maxY = Math.max(values.maxY, y);
                    });
            });

            let viewBox = `${values.minX - padding} ${values.minY - padding} ${values.maxX - values.minX + padding * 2} ${values.maxY - values.minY + padding * 2}`;

            svg.setAttribute('viewBox', viewBox);
        }
        // TODO: transfer me END

        data.mapContainer = mapContainer;

        resolve(data);
    });

    xhr.send();
});

/**
 * Initialize map with openlayers based on data.mapContainer
 * @param data
 * @returns {Promise<unknown>}
 */
const initalizeMap = (data) => new Promise((resolve, reject) => {
    let {mapContainer} = data;

    let box = mapContainer.querySelector('svg').getAttribute('viewBox');
    let [boxX, boxY, boxWidth, boxHeight] = box.split(' ');

    let targetRatio = target.clientWidth / target.clientHeight;
    let mapRatio = boxWidth / boxHeight;

    if(targetRatio > mapRatio) {
        // container wider than map => add horizontal space to map
        let newMapWidth = boxHeight * targetRatio;

        boxX = boxX - (newMapWidth - boxWidth) / 2;
        boxWidth = newMapWidth;

        mapContainer.querySelector('svg').setAttribute('viewBox', `${boxX} ${boxY} ${boxWidth} ${boxHeight}`);
    } else if(mapRatio > targetRatio) {
        // container higher than map => add vertical space to map
        let newMapHeight = boxWidth / targetRatio;

        boxY = boxY - (newMapHeight - boxHeight) / 2;
        boxHeight = newMapHeight;

        mapContainer.querySelector('svg').setAttribute('viewBox', `${boxX} ${boxY} ${boxWidth} ${boxHeight}`);
    }

    let scale = 1;

    const svgResolution = scale;
    mapContainer.style.width = boxWidth + 'px';
    mapContainer.style.height = boxHeight + 'px';
    mapContainer.style.transformOrigin = 'top left';
    mapContainer.className = 'svg-layer';

    listenerBoxWidth = boxWidth;
    listenerBoxHeight = boxHeight;

    const extent = [boxWidth / -2, boxHeight / -2, boxWidth / 2, boxHeight / 2];

    if (!mapObject) {
        const projection = new Projection({
            code: 'svg-map',
            units: 'pixels',
            extent: extent,
        });

        let resetZoomIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        resetZoomIcon.setAttribute('width', '20')
        resetZoomIcon.setAttribute('height', '20')
        resetZoomIcon.setAttribute('viewBox', '0 0 24 24')
        resetZoomIcon.innerHTML = `<g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"></path><path d="M8 2a1 1 0 0 1 .117 1.993L8 4H5a1 1 0 0 0-.993.883L4 5v3a1 1 0 0 1-1.993.117L2 8V5a3 3 0 0 1 2.824-2.995L5 2h3Zm11 0a3 3 0 0 1 2.995 2.824L22 5v3a1 1 0 0 1-1.993.117L20 8V5a1 1 0 0 0-.883-.993L19 4h-3a1 1 0 0 1-.117-1.993L16 2h3Zm2 13a1 1 0 0 1 .993.883L22 16v3a3 3 0 0 1-2.824 2.995L19 22h-3a1 1 0 0 1-.117-1.993L16 20h3a1 1 0 0 0 .993-.883L20 19v-3a1 1 0 0 1 1-1ZM3 15a1 1 0 0 1 .993.883L4 16v3a1 1 0 0 0 .883.993L5 20h3a1 1 0 0 1 .117 1.993L8 22H5a3 3 0 0 1-2.995-2.824L2 19v-3a1 1 0 0 1 1-1Z" fill="currentColor"></path></g>`

        mapObject = new Map({
            controls: defaultControls().extend([new ZoomToExtent({
                'label': resetZoomIcon
            })]),
            target: 'map-target',
            view: new View({
                center: [0, 0],
                extent: [boxWidth / -2, boxHeight / -2, boxWidth / 2, boxHeight / 2],
                projection: projection,
                zoom: 0
            }),
        });
    }


    let layers = mapObject.getLayers().getArray();
    let layerName = data.linkCommunes ? 'commune' : 'canton';

    if (layers.some(layer => layer.get('name') === layerName)) {
        // layer already exists, show it and hide others
        layers.filter(layer => layer.get('name') !== layerName).forEach(
            layer => layer.setVisible(false)
        )
        layers.filter(layer => layer.get('name') === layerName).forEach(
            layer => {
                layer.setVisible(true);

                // use layers mapObject for data.mapContainer to prevent reference errors.
                data.mapContainer = layer.get('mapContainer');
            }
        )
    } else {
        // layer doesn't exist, hide others and make new one
        layers.forEach(
            layer => layer.setVisible(false)
        )

        mapObject.addLayer(
            new Layer({
                name: layerName,
                mapContainer: mapContainer,
                render: function (frameState) {
                    let scale = svgResolution / frameState.viewState.resolution;
                    const center = frameState.viewState.center;
                    const size = frameState.size;
                    const cssTransform = composeCssTransform(
                        size[0] / 2,
                        size[1] / 2,
                        scale,
                        scale,
                        frameState.viewState.rotation,
                        -center[0] / svgResolution - boxWidth / 2,
                        center[1] / svgResolution - boxHeight / 2
                    );
                    mapContainer.style.transform = cssTransform;
                    mapContainer.style.opacity = this.getOpacity();
                    return mapContainer;
                },
            })
        );
    }

    if (!document.getElementById('canton-map-tooltip')) {
        let tooltipDiv = document.createElement('div');
        tooltipDiv.id = 'canton-map-tooltip';
        tooltipDiv.className = 'canton-map-tooltip';
        target.parentNode.insertBefore(tooltipDiv, target.nextSibling);
    }

    resolve(data);
});

/**
 * Binds click events inside the map for canton and commune preview
 *
 * Binds cantons if data.linkCantons is set
 * Binds communes if data.linkCommunes is set
 *
 * @param data
 */
const bindMapEvents = (loadFunction) => (data) => new Promise((resolve, reject) => {
    let {mapContainer, linkCantons, linkCommunes, isSR, activeCommune, language} = data;

    let cantons = mapContainer.querySelectorAll('[id*="kant"] g');
    let communes = mapContainer.querySelectorAll('[id*="voge"] g');

    let cantonLayerElement = mapContainer.querySelector('[id*="kant"]');
    let communeLayerElement = mapContainer.querySelector('[id*="voge"]');

    const resetHover = (layer) => () => {
        if (!layer) return;

        layer.classList.remove('force-hover');

        let activeElements = layer.querySelectorAll('g.force-hover');

        activeElements.forEach(element => {
            element.classList.remove('force-hover');
        })
    }

    const addHover = (layer) => (element) => {
        if (!layer) return;

        layer.classList.add('force-hover');
        element.classList.add('force-hover');
    }

    let resetCantonHover = resetHover(cantonLayerElement);
    let resetCommuneHover = resetHover(communeLayerElement);

    document.addEventListener('close-map-preview', function () {
        resetCantonHover()
    });
    document.addEventListener('close-map-preview', resetCommuneHover);

    let addCommuneHover = addHover(communeLayerElement);
    let addCantonHover = addHover(cantonLayerElement);

    // @todo adapt to 2023 when ready
    let partyColors = window.SFP.partyColors[year];

    let tooltip = document.querySelector('#canton-map-tooltip');
    let tooltipDescription = window.SFP.tooltipDescription;

    loadFunction().then(function (data) {
        let filterItems = document.querySelector('[data-info="filter-map-canton"]');
        Array.from(filterItems.children).forEach((item, index) => {
            if (index === 0) {
                return;
            }

            item.remove();
        })

        let partyNames = Object.keys(data.parteien).reduce((parties, partyNumber) => {
            parties[partyNumber] = data.parteien[partyNumber].parteiBezeichnung[language];

            return parties;
        }, {});

        var filterReset = document.querySelector('.chart-map-filter-reset');

        // remove event listeners be re-creating the element
        var newFilterReset = filterReset.cloneNode(true);
        filterReset.parentNode.replaceChild(newFilterReset, filterReset);
        filterReset = newFilterReset;

        let usedParties = [];

        resetCantonHover();
        resetCommuneHover();

        filterReset.addEventListener('click', () => {
            window.sfp.closePreview();
            resetCantonHover();
            resetCommuneHover();
        });

        if (linkCantons) {
            let cantonNames = window.SFP.cantonNames;
            cantons.forEach(canton => {
                let cantonId = canton.id;
                let lastX, lastY;
                let cantonShort = cantonMapping[cantonId];
                let cantonName = cantonNames[cantonShort] ? cantonNames[cantonShort] : cantonShort;
                let status = 0;
                let partyNumber = 0;
                let percentage = 0;
                let description = '';
                let elected = [];

                if (data[cantonShort]) {
                    if (isSR) {
                        status = parseInt(data[cantonShort].statusSR) ? parseInt(data[cantonShort].statusSR) : 0;
                    } else {
                        status = parseInt(data[cantonShort].status) ? parseInt(data[cantonShort].status) : 0;
                    }

                    partyNumber = parseInt(data[cantonShort].partyNumber) ? parseInt(data[cantonShort].partyNumber) : 0;
                    percentage = parseInt(data[cantonShort].percentage) ? parseInt(data[cantonShort].percentage) : 0;
                    elected = data[cantonShort].SR ? data[cantonShort].SR : [];
                }

                let filterItem = document.createElement('span');
                filterItem.setAttribute('class', 'table-filter');
                filterItem.innerText = cantonName;

                filterItems.append(filterItem);

                filterItem.addEventListener('click', () => {
                    resetCantonHover();
                    addCantonHover(canton);

                    window.sfp.openPreview();
                    window.sfp.initPreviewCanton(cantonShort);
                });

                switch (status) {
                    case 0:
                        canton.style.fill = '#ccc';
                        description = tooltipDescription[0];
                        break;
                    case 1:
                        canton.style.fill = 'url(#gradient)';
                        description = tooltipDescription[1];
                        break;
                    case 2:
                        if (isSR) {
                            canton.style.fill = '#DC0018';

                            description = elected.map(person => {
                                if (!SRSVG[person.gender]) return `<span class="tooltip-sr-person">${person.name} (${partyNames[person.party]})</span>`;

                                return `<span class="tooltip-sr-person">${SRSVG[person.gender].replace('###COLOR###', partyColors[person.party])} ${person.name} (${partyNames[person.party]})</span>`;
                            }).join('<br />');
                        } else {
                            canton.style.fill = partyColors[partyNumber] ? partyColors[partyNumber] : '#ccc';
                            description = tooltipDescription[2] + ' ' + partyNames[partyNumber] + ' ' + percentage + ' %';
                        }

                        if (partyNumber > 0 && !usedParties.some(x => x.number === partyNumber)) {
                            usedParties.push({
                                number: partyNumber,
                                color: partyColors[partyNumber],
                                name: partyNames[partyNumber]
                            })
                        }
                        break;
                    default:
                        canton.style.fill = '#ccc';
                        description = tooltipDescription[0];
                }

                canton.addEventListener('pointerdown', (event) => {
                    lastX = event.clientX;
                    lastY = event.clientY;
                })

                canton.addEventListener('click', (event) => {
                    let movement = Math.abs(lastX - event.clientX) + Math.abs(lastY - event.clientY);

                    // prevent drag of map to trigger preview
                    if (movement > 10) {
                        return;
                    }

                    resetCantonHover();
                    addCantonHover(canton);
                    document.dispatchEvent(
                        new CustomEvent(
                            'reset-chart-filter',
                            {detail: {chartId: 'chart-map-filter-container'}}
                        )
                    );

                    window.sfp.openPreview();
                    window.sfp.initPreviewCanton(cantonShort);
                });

                canton.addEventListener('mouseenter', function () {
                    tooltip.innerHTML = '<span class="title">' + cantonName + '</span><span class="description">' + description + '</span>';
                });

                canton.addEventListener('mouseleave', function () {
                    tooltip.classList.remove('active');
                });

                canton.addEventListener('mousemove', function (e) {
                    const pos = getTooltipPosition(e, isSR);

                    tooltip.style.left = pos.x + 'px';
                    tooltip.style.top = pos.y + 'px';

                    tooltip.classList.add('active');
                });
            });
        }

        if (linkCommunes) {
            communes = Array.prototype.map.call(communes, (commune) => {
                let element = communesData.find((element) => {
                    return element.id === commune.id;
                });

                commune.name = element.name;

                return commune;
            })

            Array.prototype.sort.call(communes, (a, b) => {
                return a.name.localeCompare(b.name)
            });

            communes.forEach(commune => {
                let communeId = commune.id;
                let lastX, lastY;
                let status = 0;
                let partyNumber = 0;
                let percentage = 0;

                let communeName = commune.name || communeId;

                let description = '';

                if (data[communeId]) {
                    status = parseInt(data[communeId].status) ? parseInt(data[communeId].status) : 0;
                    partyNumber = parseInt(data[communeId].partyNumber) ? parseInt(data[communeId].partyNumber) : 0;
                    percentage = parseInt(data[communeId].percentage) ? parseInt(data[communeId].percentage) : 0;
                }

                let filterItem = document.createElement('span');
                filterItem.setAttribute('class', 'table-filter');
                filterItem.innerText = communeName;

                filterItems.append(filterItem);

                // open preview and hover upon filter commune
                filterItem.addEventListener('click', () => {
                    resetCommuneHover();
                    addCommuneHover(commune);

                    window.sfp.openPreview();
                    window.sfp.initPreviewCommune(communeId);
                });

                switch (status) {
                    case 0:
                        commune.style.fill = '#ccc';
                        description = tooltipDescription[0];
                        break;
                    case 1:
                        commune.style.fill = 'url(#gradient)';
                        description = tooltipDescription[1];
                        break;
                    case 2:
                        commune.style.fill = partyColors[partyNumber] ? partyColors[partyNumber] : '#ccc';
                        description = tooltipDescription[2] + ' ' + partyNames[partyNumber] + ' ' + percentage + ' %';

                        if (partyNumber > 0 && !usedParties.some(x => x.number === partyNumber)) {
                            usedParties.push({
                                number: partyNumber,
                                color: partyColors[partyNumber],
                                name: partyNames[partyNumber]
                            })
                        }
                        break;
                    default:
                        commune.style.fill = '#ccc';
                        description = tooltipDescription[0];
                }

                commune.addEventListener('pointerdown', (event) => {
                    lastX = event.clientX;
                    lastY = event.clientY;
                })

                commune.addEventListener('click', (event) => {
                    let movement = Math.abs(lastX - event.clientX) + Math.abs(lastY - event.clientY);

                    // prevent drag of map to trigger preview
                    if (movement > 10) {
                        return;
                    }

                    resetCommuneHover();
                    addCommuneHover(commune);

                    document.dispatchEvent(
                        new CustomEvent(
                            'reset-chart-filter',
                            {detail: {chartId: 'chart-map-filter-container'}}
                        )
                    );
                    window.sfp.openPreview();
                    window.sfp.initPreviewCommune(communeId);
                });

                commune.addEventListener('mouseenter', function () {
                    tooltip.innerHTML = '<span class="title">' + communeName + '</span><span class="description">' + description + '</span>';
                });

                commune.addEventListener('mouseleave', function () {
                    tooltip.classList.remove('active');
                });

                commune.addEventListener('mousemove', function (e) {
                    const pos = getTooltipPosition(e, isSR);

                    tooltip.style.left = pos.x + 'px';
                    tooltip.style.top = pos.y + 'px';

                    tooltip.classList.add('active');
                });

                if (communeId === activeCommune) {
                    addCommuneHover(commune);
                }
            });
        }

        // fill legend items for SR
        if (isSR) {
            usedParties = [
                {
                    number: 2,
                    color: '#dc0018',
                    name: window.SFP.srLegendLabels[2] //todo translate
                },
                // this is not used. But in case
                // {
                //     number: 1,
                //     color: 'repeating-linear-gradient(-45deg,#ccc 0 2px,#fff 2px 4px)',
                //     name: window.SFP.srLegendLabels[1] //todo translate
                // },
                {
                    number: 0,
                    color: '#ccc',
                    name: window.SFP.srLegendLabels[0]
                }
            ]
        }

        document.getElementById('map-legend').innerHTML = `<ul>
            ${usedParties.map(party => `<li data-id="${party.number}">
            <span class="map-legend-color" style="background: ${party.color}"></span>
            ${party.name}
            </li>`).join('')}
        </ul>`;

        resolve(true);
    });
});

// 2nd initialize the map with desired configuration (canton, ch, communes, sr)
const initMapJs = (canton, forceCommunes, sr, filterElement, activeCommune, language) => {
    //console.log(canton, forceCommunes, sr, filterElement, activeCommune, language)
    let cantonMapTemplate = (canton, showCommunes) => `/static/maps/canton-map-${canton}${showCommunes ? '-full' : ''}.svg`;
    let switzerlandMapTemplate = showCommunes => `/static/maps/ch-map-${showCommunes ? 'full' : 'cantons'}.svg`;


    let textBelow = 'canton';
    if (forceCommunes) {
        textBelow = 'commune';
    }
    if (canton !== 'CH') {
        textBelow = 'commune';
    }


    let data = {
        filterElement: filterElement,
        activeCommune: activeCommune,
        language: language
    };

    let loadingFunction = null;

    const mapElement = document.getElementById('canton-map');

    if (forceCommunes) {
        mapElement.classList.add('commune-mode');
    } else {
        mapElement.classList.remove('commune-mode');
    }

    let hideFilterElement = false,
        filterElementLabel = forceCommunes ?
            window.SFP.mapSelectorLabels[1] : window.SFP.mapSelectorLabels[0];

    if (canton && canton !== 'CH') {
        data.mapPath = cantonMapTemplate(canton.toLowerCase(), forceCommunes);
        data.linkCommunes = forceCommunes;
        data.linkCantons = !forceCommunes;
        data.isCanton = true;
        data.isSR = sr;
        hideFilterElement = !forceCommunes || sr;
        loadingFunction = forceCommunes ? loadCommuneFile : loadCantonFile;
    } else if (canton === 'CH') {
        data.linkCantons = true;
        data.isSwitzerland = true;
        data.isSR = sr;

        loadingFunction = loadCantonFile;
        // forceCommune => show communes in map
        data.mapPath = switzerlandMapTemplate(forceCommunes)

        if (forceCommunes) {
            data.linkCantons = false;
            data.linkCommunes = true;
            loadingFunction = loadCommuneFile;
        }
    }

    if (!data.mapPath) return;

    if (hideFilterElement) {
        filterElement.style.display = 'none';
    } else {
        filterElement.style.display = 'initial';
        document.getElementById('canton-map-filter-text-default').innerText =
            filterElementLabel;
    }

    initializeBelowTextAndTitle({canton: canton, type: textBelow, isSr: sr})
        .then(() => loadMap(data))
        .then(initalizeMap)
        .then(bindMapEvents(loadingFunction))
}

const initializeBelowTextAndTitle = function (data) {
    return new Promise((resolve, reject) => {
        let loadFunction = null;
        let {type, canton, isSr} = data;

        if (isSr && canton !== 'CH') {
            document.getElementById('map-text-below').classList.add('hide');
            return resolve(true);
        }

        if (type === 'canton') {
            document.getElementById('map-text-below-label-canton').classList.add('show')
            document.getElementById('map-text-below-label-commune').classList.remove('show')
            loadFunction = loadCantonFile;
        }
        if (type === 'commune') {
            document.getElementById('map-text-below-label-canton').classList.remove('show')
            document.getElementById('map-text-below-label-commune').classList.add('show')
            loadFunction = loadCommuneFile;
        }

        //console.log(type, canton, loadFunction);

        loadFunction().then(data => {
            let total = Object
                .values(data).filter(entry => entry.hasOwnProperty('status'));

            if (type === 'commune' && !!canton && canton !== 'CH') {
                total = total.filter(entry => entry.canton === canton);
            }

            let counted = total.filter(entry => entry.status === 2);
            let countedSR = total.filter(entry => entry.statusSR === 2);

            document.getElementById('map-text-below-current').innerText =
                isSr ? countedSR.length : counted.length;
            document.getElementById('map-text-below-total').innerText = total.length;

            document.getElementById('map-text-below').classList.remove('hide');

            resolve(true);
        });
    });
}

// 1st on content loaded, initialize the map.
document.addEventListener('DOMContentLoaded', () => {
    const element = document.getElementById('canton-map');
    if (!element) return;

    const filterElement = document.getElementById('chart-map-filter-container');

    let canton = element.dataset.canton;
    let commune = element.dataset.commune;
    let sr = element.dataset.sr;
    let language = element.dataset.language;

    let forceCommune = false;

    if (typeof sr === 'string') {
        sr = parseInt(sr);
    }

    if (element.classList.contains('commune-mode')) {
        window.sfp.openPreview();
        window.sfp.initPreviewCommune(commune);
        forceCommune = true;
    } else if (canton && canton !== 'CH') {
        window.sfp.openPreview();
        window.sfp.initPreviewCanton(canton);
    }

    document.querySelectorAll('[name="canton-map-canton-commune-switch-radio"]').forEach(radio => {
        radio.addEventListener('change', (event) => {
            let forceCommunes = false;
            if (event.target.value === 'commune') {
                forceCommunes = true;
            }

            initMapJs(canton, forceCommunes, sr, filterElement, null, language);
        })
    });

    initMapJs(canton, forceCommune, sr, filterElement, commune, language);
});

/**
 * rules:
 *    1. button should be visible on CH page
 *    2. button should be visible on canton page in commune area
 *    3. button should never be visible on commune level (not rendered)
 *
 * @param button
 * @param canton
 * @param communeId
 */
function initButton(button, canton, communeId) {
    // context commune; rule 3.
    if (!button) return;

    let language = button.dataset.language;
    let sr = parseInt(button.dataset.sr);
    let context = button.dataset.context;

    button.style.display = 'inline-block';

    // context canton and commune. rule 2.
    if (context !== 'CH' && !communeId) {
        button.style.display = 'none';

        return;
    }

    let srPart = sr ? '/standerat' : '';
    let communePart = communeId ? `/commune/${communeId}` : '';

    button.setAttribute('href', `/${language}/${canton.toLowerCase()}${communePart}${srPart}`)
}

window.sfp.initPreviewCanton = function (canton) {
    let button = document.getElementById('canton-map-preview-button');
    initButton(button, canton, null);

    // Show canton name
    /** TODO  better canton name translation? */
    document.getElementById('canton-map-preview-header-title')
        .querySelectorAll('span')
        .forEach(canton => {
            canton.classList.add('hidden');
        });

    let labelElement = document.getElementById(`preview-canton-${canton}`);

    if (labelElement) {
        labelElement.classList.remove('hidden');
    }

    // Initialize previews
    if (!window.sfp.previewInit) {
        console.error('Missing window.sfp.previewInit. Cannot initialize previews.')
        return;
    }

    if (window.sfp.previewInit.chart01ap) window.sfp.previewInit.chart01ap(canton);
    if (window.sfp.previewInit.chart03ap) window.sfp.previewInit.chart03ap(canton);
    if (window.sfp.previewInit.chart04p) window.sfp.previewInit.chart04p(canton);
    if (window.sfp.previewInit.chart09p) window.sfp.previewInit.chart09p(canton);
    if (window.sfp.previewInit.chart15p) window.sfp.previewInit.chart15p(canton);
    if (window.sfp.previewInit.chart17p) window.sfp.previewInit.chart17p(canton);
    if (window.sfp.previewInit.chart19p) window.sfp.previewInit.chart19p(canton);
};


window.sfp.initPreviewCommune = function (communeId) {
    let commune = mappings.communes.find(commune => commune.id === communeId);
    let cantonId = commune.cantonId;
    let cantonShort = cantonMapping[cantonId];

    let button = document.getElementById('canton-map-preview-button');
    initButton(button, cantonShort, communeId);

    document.getElementById('canton-map-preview-header-title')
        .querySelectorAll('span')
        .forEach(canton => {
            canton.classList.add('hidden');
        });

    // Show commune name
    let communeTitle = document.getElementById('preview-commune');
    let communeTitleName = communeTitle.querySelector('span');
    communeTitleName.innerText = commune.name;
    communeTitleName.classList.remove('hidden');
    communeTitle.classList.remove('hidden');

    // Initialize previews
    if (window.sfp.previewInit.chart04p) window.sfp.previewInit.chart04p(cantonShort, communeId);
    if (window.sfp.previewInit.chart17p) window.sfp.previewInit.chart17p(cantonShort, communeId, commune.name);
};


function getTooltipPosition(e, isSR) {
    let cantonBody = document.querySelector('.canton-body');

    let nav =
        document.getElementsByClassName('canton-navigation-container')[0];

    const navComputedStyles = window.getComputedStyle(nav, null);
    const tooltipOffset = isSR ? 155 : 125;

    const getOffsetTop = element => {
        let offsetTop = 0;
        while(element) {
            offsetTop += element.offsetTop;
            element = element.offsetParent;
        }

        return offsetTop;
    }

    const x = e.clientX - cantonBody.offsetLeft - 5;
    const y = e.clientY - getOffsetTop(cantonBody) + window.scrollY - tooltipOffset;

    return {
        x: x,
        y: y
    }
}
